import { graphql } from "@/gen";

export const layoutTemplatesQuery = graphql(`
    query LayoutTemplates($phase: TournamentPhase) {
        tournamentLayoutTemplates(phase: $phase) {
            id
            name
            tournamentPhase
            content
            isDefault
            createdAt
            updatedAt
        }
    }
`);

export const layoutTemplateQuery = graphql(`
    query LayoutTemplate($id: UUID!) {
        tournamentLayoutTemplate(id: $id) {
            id
            name
            tournamentPhase
            content
            isDefault
            createdAt
            updatedAt
        }
    }
`);

export const createLayoutTemplateMutation = graphql(`
    mutation CreateLayoutTemplate($input: CreateTournamentLayoutTemplateInput!) {
        createTournamentLayoutTemplate(input: $input) {
            id
            name
            tournamentPhase
            content
            isDefault
            createdAt
            updatedAt
        }
    }
`);

export const updateLayoutTemplateMutation = graphql(`
    mutation UpdateLayoutTemplate($input: UpdateTournamentLayoutTemplateInput!) {
        updateTournamentLayoutTemplate(input: $input) {
            id
            name
            tournamentPhase
            content
            isDefault
            createdAt
            updatedAt
        }
    }
`);

export const deleteLayoutTemplateMutation = graphql(`
    mutation DeleteLayoutTemplate($input: DeleteTournamentLayoutTemplateInput!) {
        deleteTournamentLayoutTemplate(input: $input)
    }
`);
